import clsx from "clsx";

type ContentContainerProps = {
    children: React.ReactNode;
    className?: string;
};

const ContentContainer = ({ children, className }: ContentContainerProps) => {
    return (
        <div className={clsx("w-full max-w-6xl mx-auto px-4", className)}>
            {children}
        </div>
    );
};

export default ContentContainer;
